import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Box } from '@mui/material'
import RequireAuth from './pages/auth/RequireAuth'
import LoggedUserLayout from './pages/layout/LoggedUserLayout'
import {
  adminsRoutes,
  loggedInRoutes,
  loggedInDriverRoutes,
} from './utils/initialisations/router'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
import './App.css'
import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import DriverViewLayout from './pages/layout/DriverViewLayout'
import RequireNotDriver from './pages/auth/RequireNotDriver'
import LoadingCircular from './components/default/LoadingCircular'

const Home = lazy(() => import('./pages/Home'))
const Missing = lazy(() => import('./pages/Missing'))

dayjs.extend(updateLocale)
dayjs.extend(customParseFormat)
dayjs.extend(relativeTime)
dayjs.extend(isBetween)

dayjs.updateLocale('en', {
  weekStart: 1,
})

function App() {
  return (
    <React.Fragment>
      <Suspense
        fallback={
          <Box sx={{ height: '100vh' }}>
            <LoadingCircular />
          </Box>
        }
      >
        <Routes>
          {/* Custom pages */}
          <Route path="" element={<Home />} />

          {/* Logged users pages */}
          <Route element={<RequireAuth requiredRoles={['ROLE_USER']} />}>
            <Route element={<RequireNotDriver />}>
              <Route path="/" element={<LoggedUserLayout />}>
                {loggedInRoutes.map((route, idx) => (
                  <Route
                    key={`ar-${idx}`}
                    element={
                      <RequireAuth
                        requiredRoles={['ROLE_USER']}
                        requiredCompanyOption={route.requiredCompanyOption}
                      />
                    }
                  >
                    <Route
                      key={`lir-${idx}`}
                      path={route.path}
                      element={route.element}
                    />
                  </Route>
                ))}

                {adminsRoutes.map((adminRoute, idx) => (
                  <Route
                    key={`ar-${idx}`}
                    element={
                      <RequireAuth
                        requiredRoles={['ROLE_ADMIN', 'ROLE_ZONE_ADMIN']}
                        requiredCompanyOption={adminRoute.requiredCompanyOption}
                      />
                    }
                  >
                    <Route
                      path={adminRoute.path}
                      element={adminRoute.element}
                    />
                  </Route>
                ))}

                <Route path="*" element={<Missing />} />
              </Route>
            </Route>
            <Route path="/driver-view" element={<DriverViewLayout />}>
              {loggedInDriverRoutes.map((route, idx) => (
                <Route
                  key={`lidr-${idx}`}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </React.Fragment>
  )
}

export default App
